import React from 'react'

import SortableCellContent from './SortableCellContent'
import * as Styled from './Table.styled'

type Props = {
  containerRef?: React.RefObject<HTMLDivElement>
  loader?: React.ReactNode
  onScroll?: React.UIEventHandler<HTMLDivElement>
}

type StaticProps = {
  ResizeHandle: typeof Styled.ResizeHandle
  SelectCellContent: typeof Styled.SelectCellContent
  TextCellContent: typeof Styled.TextCellContent
  FlexCellContent: typeof Styled.FlexCellContent
  SortableCellContent: typeof SortableCellContent
}

const Table: React.FC<Props> & StaticProps = ({ containerRef, children, loader, ...props }) => {
  return (
    <Styled.Container>
      <Styled.ScrollingContainer ref={containerRef} {...props}>
        <Styled.Table cellPadding={0} cellSpacing={0}>
          {children}
        </Styled.Table>
        {loader}
      </Styled.ScrollingContainer>
      {loader}
    </Styled.Container>
  )
}

Table.ResizeHandle = Styled.ResizeHandle
Table.SelectCellContent = Styled.SelectCellContent
Table.TextCellContent = Styled.TextCellContent
Table.SortableCellContent = SortableCellContent
Table.FlexCellContent = Styled.FlexCellContent

export default Table
